import React from 'react';

export default function CardDescription({text}) {
    return (
        <div className="great-place__card__description">{text}</div>
    );
}
